import React from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import paths from '@/AppRouter/paths';
import { MIN_DESKTOP_WIDTH } from '@/constants/common';

import Burger from '@/assets/icons/Burger';
import DesktopLogo from '@/assets/images/Header_ATP_Ranking_Desctop.png';
import MobileLogo from '@/assets/images/Header_ATP_Ranking_Mobile.png';
import ArrowBack from '@/assets/images atp/arrow-left.svg';

import { useWindowSize } from '@/helpers/useWidth';

import NavigationDesktop from '../Layout/Components/NavigationDesctop/NavigationDesctop';

import {
  ArrowButton,
  BurgerButton,
  HeaderContainer,
  HeaderTopContainer,
  LogoImage,
} from './ApplicationHeader.styles';

const ApplicationHeader: React.FC<any> = ({ onBurgerClick }) => {
  const { width } = useWindowSize();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const isDesktop = width && width > MIN_DESKTOP_WIDTH;
  const showArrow = ['/rules', '/prize', 'profile'];

  return (
    <HeaderContainer>
      {pathname !== paths.guide && (
        <>
          <HeaderTopContainer>
            {showArrow.includes(pathname) && (
              <ArrowButton onClick={() => navigate(-1)}>
                <img alt='back' src={ArrowBack} />
              </ArrowButton>
            )}
            <LogoImage
              src={isDesktop ? DesktopLogo : MobileLogo}
              style={{ maxWidth: isDesktop ? '100%' : '178px' }}
            />
            <BurgerButton onClick={onBurgerClick}>
              <Burger />
            </BurgerButton>
          </HeaderTopContainer>
          {isDesktop && <NavigationDesktop />}
        </>
      )}
    </HeaderContainer>
  );
};

export default ApplicationHeader;
